import React from "react";
import { useTranslation } from "react-i18next";
import TitleSection from "../components/TitleSection/TitleSection";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleSection
        title={t("about.title")}
        subtitle={t("about.subtitle")}
        highlightWords={[
          t("about.highlightWords1"),
          t("about.highlightWords2"),
        ]}
        bgImg={Images.US_BG_IMAGE}
      />

      {/* Top Section: Image and Text */}
      <section className="flex flex-col md:flex-row items-center gap-10 mx-5 md:mx-10 my-10 h-fit">
        <div className="w-full md:w-1/2 h-[50vh] overflow-hidden rounded-xl">
          <img
            src={Images.CAMION_VERT}
            alt={t("about.camionAlt")}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="w-full md:w-1/2 flex flex-col gap-5 text-justify">
          <p>{t("about.paragraph1")}</p>
          <p>{t("about.paragraph2")}</p>
        </div>
      </section>

      {/* Quote Section */}
      <section className="flex justify-center my-24 px-5">
        <p className="relative text-3xl md:text-4xl w-full md:w-1/2 tracking-wider leading-relaxed text-center">
          <span className="text-orange md:text-7xl">“</span>
          {t("about.quote")}
          <span className="text-orange md:text-7xl">”</span>
        </p>
      </section>

      {/* Bottom Section: Image */}
      <section className="flex justify-center mx-5 md:mx-10 mb-10">
        <div className="w-full h-[50vh] overflow-hidden rounded-xl">
          <img
            src={Images.BUCHES}
            alt={t("about.buchesAlt")}
            className="w-full h-full object-cover"
          />
        </div>
      </section>

      <ContactFormPages />
    </>
  );
};

export default About;
